import { createAction } from '@reduxjs/toolkit';

export const requestSendForAmendment = createAction('admin-product/sendForAmendment');
export const requestViewProductListings = createAction('admin-product/viewProductListings');
export const requestRetrieveProductListing = createAction('admin-product/retrieveProductListing');
export const requestUpdateProductListing = createAction('admin-product/updateProductListing');
export const requestViewBuyerListings = createAction('admin-product/viewBuyerListings');
export const requestRetrieveBuyerListing = createAction('admin-product/retrieveBuyerListing');
export const requestUpdateBuyerListing = createAction('admin-product/updateBuyerListing');
export const requestViewAccounts = createAction('admin-product/viewAccounts');
export const requestApproveProduct = createAction('admin-product/approveProduct');
